<template>
  <div>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="pt-8 pb-24 md:pt-20 md:pb-32">
      <div class="container">
        <div class="mb-24 lg:mb-0 max-w-400">
          <h1 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
            Disclaimer
          </h1>
          <p class="mb-12 font-bold">Termini e condizioni di utilizzo</p>
          <p class="mb-8">
            L'accesso e l'utilizzo del presente sito www.unicreditres.it di
            UniCredit RE Services S.p.A. presuppone l'accettazione dei termini e
            delle condizioni di seguito indicate. In caso di mancata
            accettazione di tali termini e condizioni, siete invitati a non
            utilizzare il Sito. L'utente riconosce che l'utilizzo del Sito
            avviene a sua sola ed esclusiva discrezione.
          </p>
          <p class="mb-10 font-bold">Limiti di utilizzo</p>
          <p class="mb-8">
            I contenuti delle pagine e tutto il materiale pubblicato su questo
            Sito sono di proprietà esclusiva di UniCredit RE Services S.p.A. a
            cui sono riservati tutti i relativi diritti in conformità alla
            normativa vigente in materia di tutela del diritto d'autore.
            Pertanto l'appropriazione, la riproduzione, la modifica, la
            distribuzione, la ripubblicazione, dei contenuti in esso pubblicati
            non è consentita in alcuna forma anche parziale e con qualsiasi
            strumento senza il consenso scritto di UniCredit RE Services S.p.A.
            Allo stesso modo i loghi ed ogni altro segno distintivo presenti su
            questo Sito sono di proprietà di UniCredit RE Services S.p.A. e non
            possono essere utilizzati da terzi previo consenso scritto di
            UniCredit RE Services S.p.A.
          </p>
          <p class="mb-10 font-bold">Limiti di responsabilità</p>
          <p class="mb-8">
            Le informazioni contenute in questo sito si devono ritenere di
            natura meramente indicativa, e non hanno in alcun modo carattere
            contrattuale. UniCredit RE Services S.p.A. non è responsabile delle
            informazioni immesse nel Sito, della loro veridicità ed esaustività,
            e non è da ritenersi a suo carico alcun onere di verifica e di
            controllo delle stesse. Non si garantisce l'assenza di errori
            tipografici e refusi in genere. Coloro che intendano accedere ai
            servizi devono ritenere le informazioni contenute nel Sito puramente
            indicative e accertarsi dell'effettiva natura di esse e della loro
            concreta idoneità all'uso che se ne intende fare. In nessun caso
            UniCredit RE Services S.p.A. sarà ritenuta responsabile per
            qualsiasi danno diretto o indiretto, causato dall'utilizzo di questo
            Sito o dovuto ad usi illeciti e comunque impropri del medesimo da
            parte di soggetti diversi da UniCredit RE Services S.p.A.. I
            contenuti, le informazioni e i servizi descritti su questo Sito
            potranno subire modifiche od aggiornamenti senza preavviso.
          </p>
          <p class="mb-10 font-bold">
            Informativa sul trattamento dei dati personali
          </p>
          <p class="mb-4">
            In osservanza a quanto previsto dall'art. 13 del D. Lgs. 196/2003,
            Codice in Materia di Protezione dei Dati Personali, la società
            UniCredit RE Services S.p.A. informa sulle modalità e finalità del
            trattamento dei dati personali di cui viene a conoscenza per la
            gestione del presente Sito. La navigazione sul sito UniCredit RE
            Services S.p.A., al fine della consultazione dei contenuti, non
            richiede necessariamente la registrazione. La navigazione e la mera
            consultazione del Sito non implicano, generalmente, la raccolta di
            dati personali dell'Utente, comportando unicamente il trattamento
            dei cosiddetti dati di navigazione in forma anonima. Per l'acceso ad
            alcuni servizi, per i quali vengono altrimenti richiesti dei dati
            personali comprendenti tutte le informazioni che possono riferirsi a
            persone fisiche o persone giuridiche come, a titolo di esempio, il
            nome e cognome, l'indirizzo postale, l'email e il numero di
            telefono, il trattamento dei dati avverrà in modo lecito, secondo
            correttezza e in ossequio al principio di necessità. I dati
            personali che verranno forniti, volontariamente attraverso le
            interazioni con i servizi proposti, saranno trattati al solo scopo
            di adempiere agli stessi inoltrandoli all'esecutore del servizio. La
            trasmissione dei dati personali a UniCredit RE Services S.p.A.
            avviene sempre sotto la propria responsabilità.
          </p>
          <p class="mb-4">
            Qualora non si volessero più ricevere comunicazioni da UniCredit RE
            Services S.p.A. o si volesse richiedere la cancellazione dei propri
            dati personali sarà sufficiente, in qualunque momento, inoltrare
            formale richiesta all'indirizzo info@unicreditsubitocasa.it.
          </p>
          <p class="mb-4">
            Il "Titolare" del trattamento è UniCredit RE Services S.p.A., che ha
            Sede Sociale in via Livio Cambi, 5, 20151 Milano MI, mentre il
            Responsabile al quale l'interessato può rivolgersi per l'esercizio
            dei diritti di cui sopra è presso:
          </p>
          <p class="mb-8">
            UniCredit RE Services S.p.A.<br aria-hidden="true" />via Livio
            Cambi, 5<br aria-hidden="true" />20151 Milano MI<br
              aria-hidden="true"
            />Email:
            <a
              class="text-blue"
              target="_blank"
              href="mailto:privacy@unicreditreservices.it"
              >privacy@unicreditreservices.it</a
            >
          </p>
          <p class="mb-10 font-bold">Modifiche</p>
          <p class="mb-8">
            In futuro potranno essere introdotte modifiche a questa documento al
            fine di assicurare il costante rispetto delle norme di legge
            applicabili.
          </p>
          <p class="mb-10 font-bold">
            Legge applicabile e giurisdizione esclusiva
          </p>
          <p class="mb-4">
            Per quanto permesso dalla normativa applicabile e dagli accordi
            internazionali, le parti pattuiscono che la definizione di ogni
            eventuale controversia sarà di esclusiva competenza del tribunale
            dove ha sede legale UniCredit RE Services S.p.A..
          </p>
          <p class="mb-4">
            Titolare del trattamento dei dati:<br aria-hidden="true" />
            UniCredit RE Services S.p.A.<br aria-hidden="true" />via Livio
            Cambi, 5<br aria-hidden="true" />20151 Milano MI<br
              aria-hidden="true"
            />Email:
            <a
              class="text-blue"
              target="_blank"
              href="mailto:privacy@unicreditreservices.it"
              >privacy@unicreditreservices.it</a
            >
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'

export default {
  components: { BreadcrumbsWithShareAccordion },

  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.name,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title: 'Disclaimer',
          description:
            'Termini e condizioni di utilizzo del portale immobiliare UniCredit RE Services',
        }
      })
    return { meta }
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Disclaimer',
        },
      ],
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
